import { Helmet } from 'react-helmet-async'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

/**
 * Fólio (cap. 09 p.083): a trilha da rota em JetBrains Mono 13 apagado — seção à esquerda, rota à direita.
 * Mantém o BreadcrumbList JSON-LD (exatamente um por rota, ≥ 2 itens) que o SEO já indexava.
 * Rotas planas (D22): Início / <página>. Não renderiza na Home nem no sandbox.
 */
const LEAF: Record<string, string> = {
  '/genesis': 'header.genesis', '/connect': 'header.connect', '/auto-care': 'header.autoCare',
  '/about': 'header.about', '/contacts': 'header.contacts', '/terms': 'footer.termsOfService', '/privacy': 'footer.privacyPolicy',
}
const SITE = 'https://zentriz.com.br'

export default function Breadcrumbs() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  if (pathname === '/' || pathname.startsWith('/__')) return null
  const seg = pathname.split('/').filter(Boolean)
  const trail: Array<{ label: string; path?: string }> = [
    { label: t('header.home'), path: '/' },
    { label: LEAF[pathname] ? t(LEAF[pathname]) : seg[seg.length - 1] },
  ]
  const jsonLd = {
    '@context': 'https://schema.org', '@type': 'BreadcrumbList',
    itemListElement: trail.map((b, i) => ({ '@type': 'ListItem', position: i + 1, name: b.label, item: `${SITE}${b.path ?? pathname}` })),
  }
  return (
    <>
      <Helmet><script type="application/ld+json">{JSON.stringify(jsonLd)}</script></Helmet>
      <nav className="z-folio-bar" aria-label="Você está em" data-anatomy="folio">
        <ol className="z-folio-bar__trilha">
          {trail.map((b, i) => (
            <li key={i} className="z-folio-bar__item" aria-current={b.path ? undefined : 'page'}>
              {i > 0 && <span className="z-folio-bar__sep" aria-hidden="true">/</span>}
              {b.path ? <Link to={b.path} className="z-folio-bar__link">{b.label}</Link> : <span>{b.label}</span>}
            </li>
          ))}
        </ol>
        <span className="z-folio-bar__rota">{pathname}</span>
      </nav>
    </>
  )
}
